module.exports = new __parcel__URL__("myFlix-icon.4533cc8b.svg").toString();